// extracted by mini-css-extract-plugin
export default {"pageHeader":"page-header_pageHeader__5MY57","pageHeaderContainer":"page-header_pageHeaderContainer__jcXwj"};